module.exports = __webpack_public_path__ + "static/media/191CS123.cb4445f6.jpg";